export const barDummydata = [
  {
    Year: '2014', Sales: 1000, Expenses: 400, Profit: 200,
  },
  {
    Year: '2015', Sales: 1170, Expenses: 460, Profit: 200,
  },
  {
    Year: '2016', Sales: 660, Expenses: 1120, Profit: 300,
  },
  {
    Year: '2017', Sales: 1030, Expenses: 540, Profit: 350,
  },
];

export const funnelDummydata = [
  {
    Year: '2014', Sales: 1500, Expenses: 800, Profit: 700,
  },
  {
    Year: '2015', Sales: 1100, Expenses: 560, Profit: 540,
  },
  {
    Year: '2016', Sales: 730, Expenses: 415, Profit: 315,
  },
  {
    Year: '2017', Sales: 370, Expenses: 230, Profit: 140,
  },
];

export const tableDummydata = [
  { boxname: 'box1', value1: 39, value2: 30 },
  { boxname: 'box1', value1: 49, value2: 40 },
  { boxname: 'box1', value1: 29, value2: 20 },
  { boxname: 'box1', value1: 19, value2: 10 },
  { boxname: 'box2', value1: 90, value2: 90 },
  { boxname: 'box2', value1: 39, value2: 40 },
  { boxname: 'box2', value1: 56, value2: 57 },
  { boxname: 'box2', value1: 75, value2: 80 },
  { boxname: 'box3', value1: 95, value2: 90 },
  { boxname: 'box3', value1: 49, value2: 50 },
  { boxname: 'box3', value1: 60, value2: 70 },
  { boxname: 'box3', value1: 80, value2: 90 },
];

export const bubbleChartData = [
  {
    ID: 'A', X: 80, Y: 167, Temperature: 420,
  },
  {
    ID: 'B', X: 79, Y: 136, Temperature: 330,
  },
  {
    ID: 'C', x: 78, Y: 184, Temperature: 250,
  },
  {
    ID: 'D', X: 72, Y: 278, Temperature: 230,
  },
  {
    ID: 'E', X: 81, Y: 200, Temperature: 210,
  },
  {
    ID: 'F', X: 72, Y: 167, Temperature: 100,
  },
  {
    ID: 'G', X: 68, Y: 477, Temperature: 280,
  },
];

export const indicatorTracedata =  [
    {title: 'Revenue', value: 180, threshold: 170, axis: [null, 300], range1: [0, 150], range2: [150, 200], domain: { x: [0.25, 1], y: [0.08, 0.25] } },
    {title: 'Profit', value: 35, threshold: 50, axis: [null, 100], range1: [0, 25], range2: [25, 75], domain: { x: [0.25, 1], y: [0.4, 0.6] } },
    {title: 'Satisfaction', value: 220, threshold: 210, axis: [null, 300], range1: [0, 150], range2: [150, 250], domain: { x: [0.25, 1], y: [0.7, 0.9] } },
];
      
export const pieDummydata = [
  {label: 'A', value: 70},
  {label: 'B', value: 17},
  {label: 'C', value: 76},
  {label: 'D', value: 34},
  {label: 'E', value: 59},
  {label: 'F', value: 150},
  {label: 'G', value: 89},
  {label: 'H', value: 112},
];

export const dotDummydata = [
  {
    country: 'Switzerland (2011)', votingPop: 40, regVoters: 49.1, 
  },
  {
    country: 'Chile (2013)', votingPop: 45.7, regVoters: 42, 
  },
  {
    country: 'Japan (2014)', votingPop: 52, regVoters: 52.7, 
  },
  {
    country: 'United States (2012)', votingPop: 53.6, regVoters: 84.3, 
  },
  {
    country: 'Slovenia (2014)', votingPop: 54.1, regVoters: 51.7, 
  },
  {
    country: 'Canada (2011)', votingPop: 54.2, regVoters: 61.1, 
  },
  {
    country: 'Poland (2010)', votingPop: 54.5, regVoters: 55.3, 
  },
  {
    country: 'Estonia (2015)', votingPop: 54.7, regVoters: 64.2, 
  },
  {
    country: 'Luxembourg (2013)', votingPop: 55.1, regVoters: 91.1, 
  },
  {
    country: 'Portugal (2011)', votingPop: 56.7, regVoters: 58.9, 
  },

]; 

export const candleDummydata = [
  {x: '2017-01-04', open: 115.849998, close: 116.019997, high: 116.510002, low: 115.75, },
  {x: '2017-01-05', open: 115.919998, close: 116.610001, high: 116.860001, low: 115.809998, },
  {x: '2017-01-06', open: 116.779999, close: 117.910004, high: 118.160004, low: 116.470001, },
  {x: '2017-01-09', open: 117.949997, close: 118.989998, high: 119.43, low: 117.940002, },
  {x: '2017-01-10', open: 118.769997, close: 119.110001, high: 119.379997, low: 118.300003, },
  {x: '2017-01-11', open: 118.739998, close: 119.75, high: 119.93, low: 118.599998, },
  {x: '2017-01-12', open: 118.900002, close: 119.25, high: 119.300003, low: 118.209999, },
  {x: '2017-01-13', open: 119.110001, close: 119.040001, high: 119.620003, low: 118.809998, },
  {x: '2017-01-17', open: 118.339996, close: 120, high: 120.239998, low: 118.220001, },
  {x: '2017-01-18', open: 120, close: 119.989998 , high: 120.5, low: 119.709999, },
  {x: '2017-01-19', open: 119.400002, close: 119.779999, high: 120.089996, low: 119.370003, },
  {x: '2017-01-20', open: 120.449997, close: 120, high: 120.449997, low: 119.730003, },
  {x: '2017-01-23', open: 120, close: 120.080002, high: 120.809998, low: 119.769997, },
  {x: '2017-01-24', open: 119.550003, close: 119.970001, high: 120.099998, low: 119.5, },
  {x: '2017-01-25', open: 120.419998, close: 121.879997, high: 122.099998, low: 120.279999, },
  {x: '2017-01-26', open: 121.669998, close: 121.940002, high: 122.440002, low: 121.599998, },
  {x: '2017-01-27', open: 122.139999, close: 121.949997, high: 122.349998, low: 121.599998, },
  {x: '2017-01-30', open: 120.93, close: 121.629997, high: 121.629997, low: 120.660004, },
];

export const histDummydata = [  
{ x1: 16.912926841637233,
  x2: 33.82585368327447,
  y1: 23.678097578292125,
  y2: 10.147756104982339
  },
{
  x1: 13.013409237217155,
  x2: 26.02681847443431,
  y1: 18.218772932104017,
  y2: 7.808045542330293
  },
{
  x1: 29.85834211350069,
  x2: 59.71668422700138,
  y1: 41.801678958900965,
  y2: 17.915005268100415
  },
{
  x1: 41.60643255973382,
  x2: 83.21286511946764,
  y1: 58.24900558362734,
  y2: 24.96385953584029
  },
{
  x1: 29.53857097067015,
  x2: 59.0771419413403,
  y1: 41.35399935893821,
  y2: 17.72314258240209
  },
{
  x1: 11.512645911290909,
  x2: 23.025291822581817,
  y1: 16.11770427580727,
  y2: 6.907587546774545
  },
{
  x1: 17.223095658471355,
  x2: 34.44619131694271,
  y1: 24.112333921859896,
  y2: 10.333857395082813
  },
{
  x1: 12.660557824460072,
  x2: 25.321115648920145,
  y1: 17.724780954244103,
  y2: 7.5963346946760435
  },
{
  x1: 43.15717676746554,
  x2: 86.31435353493109,
  y1: 60.420047474451756,
  y2: 25.894306060479323
  },
{
  x1: 46.30775119264677,
  x2: 92.61550238529354,
  y1: 64.83085166970548,
  y2: 27.784650715588064
  },
{
  x1: 18.988712524013707,
  x2: 37.97742504802741,
  y1: 26.58419753361919,
  y2: 11.393227514408224
  },
{
  x1: 49.099215661729765,
  x2: 98.19843132345953,
  y1: 68.73890192642168,
  y2: 29.459529397037862
  },
{
  x1: 14.523093774940666,
  x2: 29.04618754988133,
  y1: 20.332331284916933,
  y2: 8.713856264964399
  },
{
  x1: 9.069994820358918,
  x2: 18.139989640717836,
  y1: 12.697992748502484,
  y2: 5.44199689221535
  },
{
  x1: 33.71035923950425,
  x2: 67.4207184790085,
  y1: 47.19450293530595,
  y2: 20.22621554370255
  },
{
  x1: 44.68567013125594,
  x2: 89.37134026251188,
  y1: 62.55993818375832,
  y2: 26.811402078753567
  },
{
  x1: 12.48734872187911,
  x2: 24.97469744375822,
  y1: 17.482288210630756,
  y2: 7.492409233127466
  },
{
  x1: 8.43874775034278,
  x2: 16.87749550068556,
  y1: 11.81424685047989,
  y2: 5.063248650205667
  },
{
  x1: 1.7881340809293933,
  x2: 3.5762681618587866,
  y1: 2.5033877133011506,
  y2: 1.072880448557636
  },
{
  x1: 8.340853654225366,
  x2: 16.681707308450733,
  y1: 11.677195115915513,
  y2: 5.00451219253522
  },
{
  x1: 15.414586232428885,
  x2: 30.82917246485777,
  y1: 21.580420725400437,
  y2: 9.24875173945733
  },
{
  x1: 6.943209651590532,
  x2: 13.886419303181064,
  y1: 9.720493512226744,
  y2: 4.165925790954319
  },
{
  x1: 32.81571728627433,
  x2: 65.63143457254866,
  y1: 45.942004200784055,
  y2: 19.689430371764594
  },
{
  x1: 20.756059181943396,
  x2: 41.51211836388679,
  y1: 29.058482854720754,
  y2: 12.453635509166038
  },
{
  x1: 8.421998689285681,
  x2: 16.843997378571363,
  y1: 11.790798164999954,
  y2: 5.053199213571409
  },
{
  x1: 1.1156515434714076,
  x2: 2.231303086942815,
  y1: 1.5619121608599706,
  y2: 0.6693909260828446
  },
{
  x1: 13.40678581147573,
  x2: 26.81357162295146,
  y1: 18.76950013606602,
  y2: 8.044071486885437
  },
{
  x1: 15.492701862284564,
  x2: 30.985403724569128,
  y1: 21.68978260719839,
  y2: 9.295621117370738
  },
{
  x1: 3.7614887744286785,
  x2: 7.522977548857357,
  y1: 5.26608428420015,
  y2: 2.256893264657207
  },
{
  x1: 32.01207518488113,
  x2: 64.02415036976225,
  y1: 44.816905258833586,
  y2: 19.207245110928678
  },
{
  x1: 15.874522223365673,
  x2: 31.749044446731347,
  y1: 22.22433111271194,
  y2: 9.524713334019403
  },
{
  x1: 16.337934905446694,
  x2: 32.67586981089339,
  y1: 22.873108867625373,
  y2: 9.802760943268016
  },
{
  x1: 9.591175335856938,
  x2: 19.182350671713877,
  y1: 13.427645470199714,
  y2: 5.754705201514163
  },
{
  x1: 44.79758459784033,
  x2: 89.59516919568065,
  y1: 62.716618436976454,
  y2: 26.878550758704193
  },
{
  x1: 9.175830956958642,
  x2: 18.351661913917283,
  y1: 12.846163339742098,
  y2: 5.505498574175185
  },
{
  x1: 44.28446984630108,
  x2: 88.56893969260216,
  y1: 61.99825778482152,
  y2: 26.57068190778065
  },
{
  x1: 40.85006186222824,
  x2: 81.70012372445647,
  y1: 57.19008660711953,
  y2: 24.510037117336942
  },
{
  x1: 16.120900983839203,
  x2: 32.241801967678406,
  y1: 22.569261377374886,
  y2: 9.672540590303523
  },
{
  x1: 38.30509352701614,
  x2: 76.61018705403228,
  y1: 53.6271309378226,
  y2: 22.983056116209685
  },
{
  x1: 28.32469957822611,
  x2: 56.64939915645222,
  y1: 39.65457940951656,
  y2: 16.99481974693567
  },
{
  x1: 8.84737056537931,
  x2: 17.69474113075862,
  y1: 12.386318791531032,
  y2: 5.308422339227585
  },
{
  x1: 32.53314881850936,
  x2: 65.06629763701872,
  y1: 45.5464083459131,
  y2: 19.519889291105613
  },
{
  x1: 7.977815378958586,
  x2: 15.955630757917172,
  y1: 11.168941530542021,
  y2: 4.786689227375152
  },
{
  x1: 13.801853565694454,
  x2: 27.60370713138891,
  y1: 19.322594991972238,
  y2: 8.281112139416674
  },
{
  x1: 1.0805214750258973,
  x2: 2.1610429500517947,
  y1: 1.5127300650362563,
  y2: 0.6483128850155384
  },
{
  x1: 0.484778018411558,
  x2: 0.969556036823116,
  y1: 0.6786892257761812,
  y2: 0.2908668110469348
  },
{
  x1: 30.516812852678257,
  x2: 61.03362570535651,
  y1: 42.72353799374956,
  y2: 18.310087711606954
  },
{
  x1: 14.759003134276972,
  x2: 29.518006268553943,
  y1: 20.66260438798776,
  y2: 8.855401880566182
  },
{
  x1: 11.902671572118539,
  x2: 23.805343144237078,
  y1: 16.663740200965954,
  y2: 7.141602943271124
  },
{
  x1: 4.778906309189457,
  x2: 9.557812618378914,
  y1: 6.690468832865239,
  y2: 2.867343785513674
  },
{
  x1: 5.366726219339735,
  x2: 10.73345243867947,
  y1: 7.513416707075629,
  y2: 3.220035731603841
  },
{
  x1: 42.687075434084164,
  x2: 85.37415086816833,
  y1: 59.76190560771782,
  y2: 25.612245260450496
  },
{
  x1: 15.53458307149288,
  x2: 31.06916614298576,
  y1: 21.74841630009003,
  y2: 9.320749842895728
  },
{
  x1: 43.82937227928309,
  x2: 87.65874455856618,
  y1: 61.36112119099633,
  y2: 26.297623367569855
  },
{
  x1: 27.94668751225035,
  x2: 55.8933750245007,
  y1: 39.125362517150485,
  y2: 16.768012507350207
  },
{
  x1: 43.040595648959474,
  x2: 86.08119129791895,
  y1: 60.256833908543264,
  y2: 25.824357389375685
  },
{
  x1: 11.635460910712814,
  x2: 23.270921821425627,
  y1: 16.289645274997937,
  y2: 6.981276546427688
  },
{
  x1: 23.007592977961437,
  x2: 46.015185955922874,
  y1: 32.21063016914601,
  y2: 13.804555786776861
  },
{
  x1: 21.693421185449502,
  x2: 43.386842370899004,
  y1: 30.370789659629303,
  y2: 13.016052711269701
  },
{
  x1: 33.505789593821845,
  x2: 67.01157918764369,
  y1: 46.908105431350585,
  y2: 20.103473756293106
  },
{
  x1: 24.21978545894923,
  x2: 48.43957091789846,
  y1: 33.90769964252892,
  y2: 14.531871275369536
  },
{
  x1: 21.206031626086997,
  x2: 42.41206325217399,
  y1: 29.6884442765218,
  y2: 12.7236189756522
  },
{
  x1: 20.776113746780787,
  x2: 41.552227493561574,
  y1: 29.086559245493106,
  y2: 12.465668248068473
  },
{
  x1: 10.609782874140661,
  x2: 21.219565748281322,
  y1: 14.853696023796925,
  y2: 6.365869724484396
  },
{
  x1: 35.118478158579066,
  x2: 70.23695631715813,
  y1: 49.1658694220107,
  y2: 21.07108689514744
  },
{
  x1: 29.06086485226193,
  x2: 58.12172970452386,
  y1: 40.685210793166696,
  y2: 17.436518911357155
  },
{
  x1: 42.23531482806977,
  x2: 84.47062965613954,
  y1: 59.12944075929768,
  y2: 25.341188896841864
  },
{
  x1: 15.351754483526591,
  x2: 30.703508967053182,
  y1: 21.49245627693723,
  y2: 9.211052690115956
  },
{
  x1: 6.476966840116849,
  x2: 12.953933680233698,
  y1: 9.06775357616359,
  y2: 3.8861801040701094
  },
{
  x1: 36.86993614453268,
  x2: 73.73987228906536,
  y1: 51.61791060234575,
  y2: 22.121961686719608
  },
{
  x1: 13.05610461204184,
  x2: 26.11220922408368,
  y1: 18.278546456858578,
  y2: 7.833662767225105
  },
{
  x1: 28.696754131293236,
  x2: 57.39350826258647,
  y1: 40.175455783810534,
  y2: 17.21805247877594
  },
{
  x1: 47.19904143397539,
  x2: 94.39808286795078,
  y1: 66.07865800756554,
  y2: 28.319424860385233
  },
{
  x1: 34.32116985755535,
  x2: 68.6423397151107,
  y1: 48.049637800577486,
  y2: 20.592701914533208
  },
{
  x1: 38.12616237313398,
  x2: 76.25232474626796,
  y1: 53.37662732238756,
  y2: 22.875697423880386
  },
{
  x1: 27.10539042695256,
  x2: 54.21078085390512,
  y1: 37.947546597733584,
  y2: 16.263234256171536
  },
{
  x1: 35.08017050183193,
  x2: 70.16034100366386,
  y1: 49.11223870256471,
  y2: 21.04810230109916
  },
{
  x1: 16.311296328081827,
  x2: 32.622592656163654,
  y1: 22.835814859314556,
  y2: 9.786777796849096
  },
{
  x1: 12.602452202732362,
  x2: 25.204904405464724,
  y1: 17.643433083825308,
  y2: 7.5614713216394165
  },
{
  x1: 13.873066473979156,
  x2: 27.746132947958312,
  y1: 19.42229306357082,
  y2: 8.323839884387494
  },
{
  x1: 11.457480424037048,
  x2: 22.914960848074095,
  y1: 16.040472593651867,
  y2: 6.8744882544222286
  },
{
  x1: 35.613613109444344,
  x2: 71.22722621888869,
  y1: 49.85905835322208,
  y2: 21.368167865666607
  },
{
  x1: 39.23244038888256,
  x2: 78.46488077776512,
  y1: 54.925416544435585,
  y2: 23.539464233329536
  },
{
  x1: 42.19839364593523,
  x2: 84.39678729187045,
  y1: 59.07775110430932,
  y2: 25.31903618756114
  },
{
  x1: 38.80705140489773,
  x2: 77.61410280979545,
  y1: 54.32987196685682,
  y2: 23.284230842938637
  },
{
  x1: 21.890070631038338,
  x2: 43.780141262076675,
  y1: 30.646098883453675,
  y2: 13.134042378623004
  },
{
  x1: 27.936149986163016,
  x2: 55.87229997232603,
  y1: 39.11060998062822,
  y2: 16.761689991697807
  },
{
  x1: 22.482976597451945,
  x2: 44.96595319490389,
  y1: 31.476167236432723,
  y2: 13.489785958471167
  },
{
  x1: 44.81242954247239,
  x2: 89.62485908494477,
  y1: 62.73740135946134,
  y2: 26.88745772548343
  },
{
  x1: 18.17889687366321,
  x2: 36.35779374732642,
  y1: 25.45045562312849,
  y2: 10.907338124197924
  },
{
  x1: 14.49705330543991,
  x2: 28.99410661087982,
  y1: 20.295874627615873,
  y2: 8.698231983263947
  },
{
  x1: 27.932361330877864,
  x2: 55.86472266175573,
  y1: 39.105305863229006,
  y2: 16.75941679852672
  },
{
  x1: 47.074891352934856,
  x2: 94.14978270586971,
  y1: 65.9048478941088,
  y2: 28.244934811760913
  },
{
  x1: 49.71484841221403,
  x2: 99.42969682442806,
  y1: 69.60078777709964,
  y2: 29.828909047328416
  },
{
  x1: 5.898601229939504,
  x2: 11.797202459879008,
  y1: 8.258041721915305,
  y2: 3.5391607379637025
  },
{
  x1: 11.68138299746061,
  x2: 23.36276599492122,
  y1: 16.353936196444852,
  y2: 7.008829798476366
  },
{
  x1: 17.54586389668432,
  x2: 35.09172779336864,
  y1: 24.56420945535805,
  y2: 10.527518338010593
  },
{
  x1: 12.383683712417659,
  x2: 24.767367424835317,
  y1: 17.337157197384723,
  y2: 7.430210227450596
  },
{
  x1: 22.050071282816653,
  x2: 44.100142565633305,
  y1: 30.870099795943318,
  y2: 13.230042769689993
  },
{
  x1: 44.53074737662136,
  x2: 89.06149475324273,
  y1: 62.34304632726992,
  y2: 26.71844842597282
  },
{
  x1: 6.420926469803456,
  x2: 12.841852939606913,
  y1: 8.989297057724839,
  y2: 3.8525558818820738
  },
{
  x1: 13.864317673415872,
  x2: 27.728635346831744,
  y1: 19.41004474278222,
  y2: 8.318590604049522
  },
{
  x1: 47.689202851980745,
  x2: 95.37840570396149,
  y1: 66.76488399277304,
  y2: 28.613521711188447
  },
{
  x1: 15.491944493878584,
  x2: 30.98388898775717,
  y1: 21.688722291430018,
  y2: 9.29516669632715
  },
{
  x1: 40.52362712116832,
  x2: 81.04725424233663,
  y1: 56.733077969635644,
  y2: 24.31417627270099
  },
{
  x1: 27.582063704481854,
  x2: 55.16412740896371,
  y1: 38.614889186274596,
  y2: 16.549238222689112
  },
{
  x1: 14.835563874674051,
  x2: 29.671127749348102,
  y1: 20.76978942454367,
  y2: 8.901338324804431
  },
{
  x1: 24.471287325148687,
  x2: 48.942574650297374,
  y1: 34.25980225520816,
  y2: 14.682772395089211
  },
{
  x1: 9.410977516514773,
  x2: 18.821955033029546,
  y1: 13.175368523120683,
  y2: 5.646586509908865
  },
{
  x1: 40.77574977723976,
  x2: 81.55149955447952,
  y1: 57.08604968813566,
  y2: 24.465449866343853
  },
{
  x1: 10.183953233218135,
  x2: 20.36790646643627,
  y1: 14.257534526505388,
  y2: 6.1103719399308805
  },
{
  x1: 29.948618954941985,
  x2: 59.89723790988397,
  y1: 41.92806653691878,
  y2: 17.969171372965192
  },
{
  x1: 28.142382143830137,
  x2: 56.28476428766027,
  y1: 39.39933500136219,
  y2: 16.88542928629808
  },
{
  x1: 43.97120420775444,
  x2: 87.94240841550888,
  y1: 61.559685890856215,
  y2: 26.382722524652664
  },
{
  x1: 0.08302594904346927,
  x2: 0.16605189808693854,
  y1: 0.11623632866085698,
  y2: 0.04981556942608156
  },
{
  x1: 25.62874784828797,
  x2: 51.25749569657594,
  y1: 35.88024698760316,
  y2: 15.377248708972783
  },
{
  x1: 18.409525535135195,
  x2: 36.81905107027039,
  y1: 25.773335749189275,
  y2: 11.045715321081119
  },
{
  x1: 30.0589994672149,
  x2: 60.1179989344298,
  y1: 42.082599254100856,
  y2: 18.03539968032894
  },
{
  x1: 10.871916638029377,
  x2: 21.743833276058755,
  y1: 15.220683293241128,
  y2: 6.5231499828176265
  },
{
  x1: 24.785976500041997,
  x2: 49.571953000083994,
  y1: 34.70036710005879,
  y2: 14.871585900025197
  },
{
  x1: 38.702544928437945,
  x2: 77.40508985687589,
  y1: 54.18356289981312,
  y2: 23.221526957062764
  },
{
  x1: 39.99311002087964,
  x2: 79.98622004175928,
  y1: 55.9903540292315,
  y2: 23.995866012527785
  },
{
  x1: 46.233999132176066,
  x2: 92.46799826435213,
  y1: 64.7275987850465,
  y2: 27.740399479305637
  },
{
  x1: 25.216505709954752,
  x2: 50.433011419909505,
  y1: 35.30310799393665,
  y2: 15.12990342597285
  },
{
  x1: 34.05868270904477,
  x2: 68.11736541808953,
  y1: 47.68215579266267,
  y2: 20.435209625426857
  },
{
  x1: 19.191201339071917,
  x2: 38.38240267814383,
  y1: 26.867681874700683,
  y2: 11.51472080344315
  },
{
  x1: 21.71076915801262,
  x2: 43.42153831602524,
  y1: 30.39507682121767,
  y2: 13.026461494807574
  },
{
  x1: 48.32664118187058,
  x2: 96.65328236374116,
  y1: 67.65729765461882,
  y2: 28.995984709122347
  },
{
  x1: 7.797650985120375,
  x2: 15.59530197024075,
  y1: 10.916711379168525,
  y2: 4.678590591072225
  },
{
  x1: 49.570251566084025,
  x2: 99.14050313216805,
  y1: 69.39835219251763,
  y2: 29.742150939650415
  },
{
  x1: 33.83744040322259,
  x2: 67.67488080644517,
  y1: 47.37241656451162,
  y2: 20.30246424193355
  },
{
  x1: 15.971708325881506,
  x2: 31.943416651763012,
  y1: 22.360391656234107,
  y2: 9.583024995528904
  },
{
  x1: 8.60058555713974,
  x2: 17.20117111427948,
  y1: 12.040819779995635,
  y2: 5.160351334283844
  },
{
  x1: 30.133956101016146,
  x2: 60.26791220203229,
  y1: 42.187538541422605,
  y2: 18.080373660609688
  },
{
  x1: 5.424670445038582,
  x2: 10.849340890077164,
  y1: 7.594538623054015,
  y2: 3.254802267023149
  },
{
  x1: 39.91235079799892,
  x2: 79.82470159599784,
  y1: 55.87729111719848,
  y2: 23.94741047879935
  },
{
  x1: 28.85727444958899,
  x2: 57.71454889917798,
  y1: 40.40018422942458,
  y2: 17.31436466975339
  },
{
  x1: 45.50689289105799,
  x2: 91.01378578211597,
  y1: 63.70965004748119,
  y2: 27.304135734634794
  },
{
  x1: 20.037866333694954,
  x2: 40.07573266738991,
  y1: 28.053012867172935,
  y2: 12.022719800216972
  },
{
  x1: 32.86030977835075,
  x2: 65.7206195567015,
  y1: 46.00443368969105,
  y2: 19.71618586701045
  },
{
  x1: 5.251925165524307,
  x2: 10.503850331048614,
  y1: 7.35269523173403,
  y2: 3.1511550993145843
  },
{
  x1: 45.21256288573885,
  x2: 90.4251257714777,
  y1: 63.29758804003439,
  y2: 27.12753773144331
  },
{
  x1: 38.460041430236025,
  x2: 76.92008286047205,
  y1: 53.844058002330435,
  y2: 23.076024858141615
  },
{
  x1: 25.692645462967214,
  x2: 51.38529092593443,
  y1: 35.969703648154095,
  y2: 15.415587277780327
  },
{
  x1: 21.176369000561458,
  x2: 42.352738001122916,
  y1: 29.64691660078604,
  y2: 12.705821400336873
  },
{
  x1: 32.650126721709825,
  x2: 65.30025344341965,
  y1: 45.710177410393754,
  y2: 19.590076033025895
  },
{
  x1: 15.682092938899384,
  x2: 31.364185877798768,
  y1: 21.95493011445914,
  y2: 9.40925576333963
  },
{
  x1: 38.64250897240722,
  x2: 77.28501794481444,
  y1: 54.099512561370105,
  y2: 23.18550538344433
  },
{
  x1: 5.193379870984205,
  x2: 10.38675974196841,
  y1: 7.270731819377887,
  y2: 3.116027922590523
  },
{
  x1: 30.92414292278546,
  x2: 61.84828584557092,
  y1: 43.29380009189964,
  y2: 18.554485753671276
  },
{
  x1: 4.883030749987993,
  x2: 9.766061499975986,
  y1: 6.8362430499831905,
  y2: 2.929818449992796
  },
{
  x1: 47.2694543497635,
  x2: 94.538908699527,
  y1: 66.1772360896689,
  y2: 28.361672609858097
  },
{
  x1: 23.914596844809665,
  x2: 47.82919368961933,
  y1: 33.48043558273353,
  y2: 14.348758106885798
  },
{
  x1: 15.401087856896956,
  x2: 30.80217571379391,
  y1: 21.561522999655736,
  y2: 9.240652714138173
  },
{
  x1: 41.04032457212878,
  x2: 82.08064914425756,
  y1: 57.4564544009803,
  y2: 24.624194743277272
  },
{
  x1: 48.28195226860318,
  x2: 96.56390453720635,
  y1: 67.59473317604446,
  y2: 28.96917136116191
  },
{
  x1: 15.323754664992418,
  x2: 30.647509329984835,
  y1: 21.453256530989385,
  y2: 9.19425279899545
  },
{
  x1: 3.4823099286945602,
  x2: 6.9646198573891205,
  y1: 4.875233900172384,
  y2: 2.089385957216736
  },
{
  x1: 1.7881592392409718,
  x2: 3.5763184784819435,
  y1: 2.5034229349373605,
  y2: 1.072895543544583
  },
{
  x1: 39.73192469265503,
  x2: 79.46384938531006,
  y1: 55.62469456971704,
  y2: 23.83915481559302
  },
{
  x1: 39.15998959464631,
  x2: 78.31997918929262,
  y1: 54.82398543250484,
  y2: 23.49599375678779
  },
{
  x1: 28.448436099760652,
  x2: 56.896872199521304,
  y1: 39.82781053966491,
  y2: 17.06906165985639
  },
{
  x1: 45.48359329858535,
  x2: 90.9671865971707,
  y1: 63.67703061801949,
  y2: 27.29015597915121
  },
{
  x1: 1.2305646912402768,
  x2: 2.4611293824805536,
  y1: 1.7227905677363875,
  y2: 0.7383388147441661
  },
{
  x1: 20.794299357963464,
  x2: 41.58859871592693,
  y1: 29.11201910114885,
  y2: 12.476579614778078
  },
{
  x1: 20.223957572367325,
  x2: 40.44791514473465,
  y1: 28.31354060131425,
  y2: 12.134374543420394
  },
{
  x1: 44.35942133156421,
  x2: 88.71884266312841,
  y1: 62.10318986418989,
  y2: 26.615652798938527
  },
{
  x1: 43.69171474017329,
  x2: 87.38342948034658,
  y1: 61.16840063624261,
  y2: 26.215028844103976
  },
{
  x1: 43.603079849179515,
  x2: 87.20615969835903,
  y1: 61.04431178885132,
  y2: 26.161847909507706
  },
{
  x1: 9.828041809255373,
  x2: 19.656083618510745,
  y1: 13.75925853295752,
  y2: 5.896825085553223
  },
{
  x1: 14.787328572171699,
  x2: 29.574657144343398,
  y1: 20.70226000104038,
  y2: 8.872397143303019
  },
{
  x1: 22.638452287294598,
  x2: 45.276904574589196,
  y1: 31.693833202212435,
  y2: 13.583071372376757
  },
{
  x1: 6.203688113413519,
  x2: 12.407376226827038,
  y1: 8.685163358778926,
  y2: 3.7222128680481115
  },
];

export const ParallelDummydata = [
  {
    Hair: 'Black', Eye: 'Brown', Sex: 'Female',  count: 6,
  },
  {
    Hair: 'Brown', Eye: 'Brown', Sex: 'Male', count: 10,
  },
  {
    Hair: 'Brown', Eye: 'Brown', Sex: 'Female', count: 40,
  },
  {
    Hair: 'Brown', Eye: 'Blue', Sex: 'Male', count: 23,
  },
  {
    Hair: 'Red', Eye: 'Blue', Sex: 'Male', count: 7,
  },
];

export const ContourDummydata = [
  {z1: 1.709116524226788, z2: 5.981907834793758, z3: 2.563674786340182, z4: 3.418233048453576, z5: 0.854558262113394,},
  {z1: 15.214517417942034, z2: 53.25081096279712, z3: 22.82177612691305, z4: 30.429034835884067, z5: 7.607258708971017,},
  {z1: 7.713412548387795, z2: 26.99694391935728, z3: 11.570118822581692, z4: 15.42682509677559, z5: 3.8567062741938973,},
  {z1: 1.2622849659851898, z2: 4.417997380948164, z3: 1.8934274489777847, z4: 2.5245699319703796, z5: 0.6311424829925949,},
  {z1: 1.8862853452375195, z2: 6.601998708331318, z3: 2.829428017856279, z4: 3.772570690475039, z5: 0.9431426726187597,},
  {z1: 3.9551358919038293, z2: 13.842975621663403, z3: 5.932703837855744, z4: 7.910271783807659, z5: 1.9775679459519147,},
  {z1: 3.529243540560838, z2: 12.352352391962933, z3: 5.293865310841257, z4: 7.058487081121676, z5: 1.764621770280419,},
  {z1: 4.18459693073741, z2: 14.646089257580934, z3: 6.276895396106115, z4: 8.36919386147482, z5: 2.092298465368705,},
  {z1: 5.737334103188729, z2: 20.080669361160552, z3: 8.606001154783094, z4: 11.474668206377459, z5: 2.8686670515943646,},
];

export const HeatDummydata = [
  {label:'A', z1: 1.709116524226788, z2: 5.981907834793758, z3: 2.563674786340182, z4: 3.418233048453576, z5: 0.854558262113394,},
  {label:'B', z1: 15.214517417942034, z2: 53.25081096279712, z3: 22.82177612691305, z4: 30.429034835884067, z5: 7.607258708971017,},
  {label:'C', z1: 7.713412548387795, z2: 26.99694391935728, z3: 11.570118822581692, z4: 15.42682509677559, z5: 3.8567062741938973,},
  {label:'D', z1: 1.2622849659851898, z2: 4.417997380948164, z3: 1.8934274489777847, z4: 2.5245699319703796, z5: 0.6311424829925949,},
  {label:'E', z1: 1.8862853452375195, z2: 6.601998708331318, z3: 2.829428017856279, z4: 3.772570690475039, z5: 0.9431426726187597,},
  {label:'F', z1: 3.9551358919038293, z2: 13.842975621663403, z3: 5.932703837855744, z4: 7.910271783807659, z5: 1.9775679459519147,},
  {label:'G', z1: 3.529243540560838, z2: 12.352352391962933, z3: 5.293865310841257, z4: 7.058487081121676, z5: 1.764621770280419,},
  {label:'H', z1: 4.18459693073741, z2: 14.646089257580934, z3: 6.276895396106115, z4: 8.36919386147482, z5: 2.092298465368705,},
  {label:'I', z1: 5.737334103188729, z2: 20.080669361160552, z3: 8.606001154783094, z4: 11.474668206377459, z5: 2.8686670515943646,},
];

export const treeDummydata = [
  {label: 'Eve', parent: '', value: 10,},
  {label: 'Cain', parent: 'Eve', value: 14,},
  {label: 'Seth', parent: 'Eve', value: 18,},
  {label: 'Enos', parent: 'Seth', value: 12,},
  {label: 'Noam', parent: 'Seth', value: 6,},
  {label: 'Abel', parent: 'Eve', value: 13,},
  {label: 'Awan', parent: 'Eve', value: 3,},
  {label: 'Enoch', parent: 'Awan', value: 1,},
  {label: 'Azura', parent: 'Eve', value: 8,},
];

export const violinDummydata = [
{ Day: 'Saturday', Value: 0.6076026877760019 },
{ Day: 'Monday', Value: 1.5480984263626407 },
{ Day: 'Monday', Value: 0.9880087523003303 },
{ Day: 'Thursday', Value: 3.992922800289352 },
{ Day: 'Saturday', Value: 0.7415701007017128 },
{ Day: 'Thursday', Value: 3.5126210290765183 },
{ Day: 'Saturday', Value: 1.766777102065482 },
{ Day: 'Sunday', Value: 2.1751833898792636 },
{ Day: 'Sunday', Value: 5.312061168182959 },
{ Day: 'Friday', Value: 3.7757255804352607 },
{ Day: 'Saturday', Value: 8.923049941607573 },
{ Day: 'Thursday', Value: 10.371429210989923 },
{ Day: 'Friday', Value: 11.479854027462888 },
{ Day: 'Tuesday', Value: 6.079070901019703 },
{ Day: 'Wednesday', Value: 1.846235907657332 },
{ Day: 'Sunday', Value: 5.922753099260834 },
{ Day: 'Friday', Value: 16.505455903859804 },
{ Day: 'Wednesday', Value: 17.279454645933598 },
{ Day: 'Friday', Value: 9.591071765237698 },
{ Day: 'Sunday', Value: 19.850479023037582 },
{ Day: 'Sunday', Value: 12.378511266666493 },
{ Day: 'Saturday', Value: 7.954873419061889 },
{ Day: 'Thursday', Value: 12.723398468695274 },
{ Day: 'Sunday', Value: 19.267021948103874 },
{ Day: 'Wednesday', Value: 19.538103188942735 },
{ Day: 'Sunday', Value: 2.8253325329339134 },
{ Day: 'Friday', Value: 24.669530077866092 },
{ Day: 'Sunday', Value: 4.576826636276743 },
{ Day: 'Saturday', Value: 3.0632152076483727 },
{ Day: 'Thursday', Value: 22.1943469080171 },
{ Day: 'Thursday', Value: 0.17811173777050482 },
{ Day: 'Sunday', Value: 21.036448241871312 },
{ Day: 'Wednesday', Value: 12.12873256621517 },
{ Day: 'Saturday', Value: 33.49702988678024 },
{ Day: 'Thursday', Value: 24.995352240819436 },
{ Day: 'Friday', Value: 22.841781545058012 },
{ Day: 'Friday', Value: 5.954148156767518 },
{ Day: 'Saturday', Value: 2.4608330692521374 },
{ Day: 'Tuesday', Value: 4.6364624234895855 },
{ Day: 'Monday', Value: 24.432853260935765 },
{ Day: 'Tuesday', Value: 32.22679818670479 },
{ Day: 'Sunday', Value: 32.56947094078162 },
{ Day: 'Tuesday', Value: 14.552142776776275 },
{ Day: 'Thursday', Value: 1.2260254297153006 },
{ Day: 'Thursday', Value: 17.489750354595802 },
{ Day: 'Friday', Value: 24.081269015068628 },
{ Day: 'Wednesday', Value: 23.817481995548047 },
{ Day: 'Thursday', Value: 29.589126619016476 },
{ Day: 'Wednesday', Value: 7.416689811368077 },
{ Day: 'Saturday', Value: 0.8814382656977648 },
{ Day: 'Sunday', Value: 0.31033177561236647 },
{ Day: 'Friday', Value: 18.08895384889564 },
{ Day: 'Wednesday', Value: 11.150681590794527 },
{ Day: 'Thursday', Value: 47.499743376592704 },
{ Day: 'Saturday', Value: 3.842069701980584 },
{ Day: 'Saturday', Value: 21.814955835381326 },
{ Day: 'Monday', Value: 12.912278064841576 },
{ Day: 'Saturday', Value: 44.57474801065872 },
{ Day: 'Tuesday', Value: 0.5079803818782098 },
{ Day: 'Monday', Value: 42.40858956547105 },
{ Day: 'Friday', Value: 41.99994134244071 },
{ Day: 'Monday', Value: 27.33938966430118 },
{ Day: 'Sunday', Value: 19.847151657697545 },
{ Day: 'Saturday', Value: 40.69604568786258 },
{ Day: 'Sunday', Value: 35.58689907009744 },
{ Day: 'Saturday', Value: 4.970825134304961 },
{ Day: 'Saturday', Value: 41.29353929596 },
{ Day: 'Wednesday', Value: 66.78354738152545 },
{ Day: 'Saturday', Value: 42.47277646445253 },
{ Day: 'Tuesday', Value: 50.072019251176656 },
{ Day: 'Wednesday', Value: 70.45435376519279 },
{ Day: 'Sunday', Value: 55.48775654736687 },
{ Day: 'Sunday', Value: 9.437349952708061 },
{ Day: 'Saturday', Value: 43.28464215661728 },
{ Day: 'Tuesday', Value: 56.36085752205427 },
{ Day: 'Monday', Value: 26.334543852032017 },
{ Day: 'Monday', Value: 22.893110028533037 },
{ Day: 'Friday', Value: 65.78926641054792 },
{ Day: 'Friday', Value: 71.97415184022019 },
{ Day: 'Monday', Value: 76.61360121990803 },
{ Day: 'Sunday', Value: 14.836321425693573 },
{ Day: 'Saturday', Value: 26.27549304691483 },
{ Day: 'Thursday', Value: 35.53332472118721 },
{ Day: 'Friday', Value: 63.847780570988064 },
{ Day: 'Sunday', Value: 5.445774913039387 },
{ Day: 'Wednesday', Value: 44.78967168589453 },
{ Day: 'Saturday', Value: 27.777789374087202 },
{ Day: 'Sunday', Value: 21.164537565499508 },
{ Day: 'Tuesday', Value: 0.656782137740078 },
{ Day: 'Tuesday', Value: 1.1997454613029879 },
{ Day: 'Tuesday', Value: 59.642019607478126 },
{ Day: 'Saturday', Value: 58.228443381494195 },
{ Day: 'Monday', Value: 52.18285496457186 },
{ Day: 'Wednesday', Value: 47.713235549022016 },
{ Day: 'Friday', Value: 77.01100795355129 },
{ Day: 'Saturday', Value: 10.44888101967667 },
{ Day: 'Thursday', Value: 32.40098997417904 },
{ Day: 'Wednesday', Value: 31.906694637807423 },
{ Day: 'Saturday', Value: 76.43014874877318 },
{ Day: 'Thursday', Value: 60.474252096269396 },
{ Day: 'Tuesday', Value: 94.73521673831623 },
{ Day: 'Saturday', Value: 86.33682406401348 },
{ Day: 'Thursday', Value: 83.67271319137768 },
{ Day: 'Friday', Value: 30.5403872148309 },
{ Day: 'Thursday', Value: 70.95737332277164 },
{ Day: 'Monday', Value: 54.412612851852074 },
{ Day: 'Friday', Value: 36.48892338990381 },
{ Day: 'Sunday', Value: 21.53044884117828 },
{ Day: 'Saturday', Value: 72.99815106946981 },
{ Day: 'Monday', Value: 18.547566413531683 },
{ Day: 'Wednesday', Value: 82.43744966961984 },
{ Day: 'Saturday', Value: 22.559707448782323 },
{ Day: 'Tuesday', Value: 82.40350490605712 },
{ Day: 'Tuesday', Value: 88.72881550360727 },
{ Day: 'Tuesday', Value: 88.29305412502939 },
{ Day: 'Wednesday', Value: 74.58722794927495 },
{ Day: 'Friday', Value: 52.48347273891813 },
{ Day: 'Thursday', Value: 58.8867856937446 },
{ Day: 'Thursday', Value: 113.75858060133041 },
{ Day: 'Monday', Value: 46.46463824736717 },
{ Day: 'Saturday', Value: 101.64547543457775 },
{ Day: 'Monday', Value: 101.45153280625419 },
{ Day: 'Friday', Value: 103.57752245732918 },
{ Day: 'Thursday', Value: 27.761958089444157 },
{ Day: 'Monday', Value: 75.68930946062564 },
{ Day: 'Sunday', Value: 41.86226595621384 },
{ Day: 'Tuesday', Value: 3.919319720221724 },
{ Day: 'Friday', Value: 100.41152096769599 },
{ Day: 'Saturday', Value: 117.24972429248407 },
{ Day: 'Wednesday', Value: 129.90049889311385 },
{ Day: 'Friday', Value: 82.04193290759181 },
{ Day: 'Sunday', Value: 14.308809259700592 },
{ Day: 'Sunday', Value: 42.16892109659045 },
{ Day: 'Monday', Value: 128.29186025644273 },
{ Day: 'Wednesday', Value: 56.286508501732726 },
{ Day: 'Wednesday', Value: 3.678300998820559 },
{ Day: 'Friday', Value: 22.613519323500956 },
{ Day: 'Monday', Value: 119.50491249888454 },
{ Day: 'Friday', Value: 51.13267102968286 },
{ Day: 'Monday', Value: 54.80072030163797 },
{ Day: 'Tuesday', Value: 69.04753459841332 },
{ Day: 'Thursday', Value: 92.33360268279932 },
{ Day: 'Sunday', Value: 141.03345553579442 },
{ Day: 'Monday', Value: 122.14680344440717 },
{ Day: 'Friday', Value: 73.19185638351242 },
{ Day: 'Wednesday', Value: 101.2320301842954 },
{ Day: 'Sunday', Value: 140.62061941284102 },
{ Day: 'Monday', Value: 103.11841401123645 },
{ Day: 'Wednesday', Value: 133.0496860300846 },
{ Day: 'Monday', Value: 27.390430244450815 },
{ Day: 'Thursday', Value: 129.3136185855995 },
{ Day: 'Tuesday', Value: 80.14188149978402 },
{ Day: 'Monday', Value: 113.15325526954544 },
{ Day: 'Tuesday', Value: 56.00856876444259 },
{ Day: 'Monday', Value: 146.0183480566908 },
{ Day: 'Tuesday', Value: 108.93210470430797 },
{ Day: 'Tuesday', Value: 88.45506771566805 },
{ Day: 'Sunday', Value: 9.398370163541928 },
{ Day: 'Tuesday', Value: 139.47079291062727 },
{ Day: 'Thursday', Value: 67.45748658137427 },
{ Day: 'Tuesday', Value: 20.22825109430816 },
{ Day: 'Tuesday', Value: 124.50030722093612 },
{ Day: 'Monday', Value: 84.28909258886915 },
{ Day: 'Tuesday', Value: 20.771451714799078 },
{ Day: 'Sunday', Value: 64.08768986641198 },
{ Day: 'Saturday', Value: 93.78577824174072 },
{ Day: 'Tuesday', Value: 2.0809972247749453 },
{ Day: 'Sunday', Value: 97.10049891651086 },
{ Day: 'Wednesday', Value: 129.50945096371453 },
{ Day: 'Thursday', Value: 125.32367580354224 },
{ Day: 'Tuesday', Value: 27.11539240079181 },
{ Day: 'Wednesday', Value: 43.88854212732946 },
{ Day: 'Monday', Value: 161.72905806030187 },
{ Day: 'Saturday', Value: 55.95835775158309 },
{ Day: 'Thursday', Value: 41.85736588980894 },
{ Day: 'Monday', Value: 61.141303423008395 },
{ Day: 'Wednesday', Value: 174.89822743595585 },
{ Day: 'Saturday', Value: 18.693654749918863 },
{ Day: 'Monday', Value: 48.092459194598895 },
{ Day: 'Wednesday', Value: 105.24983339337422 },
{ Day: 'Monday', Value: 133.12251900608592 },
{ Day: 'Thursday', Value: 175.84453331852285 },
{ Day: 'Sunday', Value: 124.7567563657615 },
{ Day: 'Tuesday', Value: 8.518177125908569 },
{ Day: 'Thursday', Value: 157.32358631375345 },
{ Day: 'Wednesday', Value: 100.22197197307214 },
{ Day: 'Thursday', Value: 37.90029206659334 },
{ Day: 'Wednesday', Value: 100.83747293244392 },
{ Day: 'Wednesday', Value: 118.60167108107909 },
{ Day: 'Friday', Value: 83.7118648845141 },
{ Day: 'Monday', Value: 65.0271660531494 },
{ Day: 'Wednesday', Value: 78.90508424226456 },
{ Day: 'Tuesday', Value: 188.34369565837622 },
{ Day: 'Friday', Value: 33.10977875531019 },
{ Day: 'Wednesday', Value: 91.142552764666 },
{ Day: 'Saturday', Value: 163.37108667945563 },
{ Day: 'Monday', Value: 112.15562146000254 },
{ Day: 'Friday', Value: 151.6268306532858 },
{ Day: 'Thursday', Value: 177.39696284113694 },
];

export const waterDummydata = [
  {xLabel: 'Sales', yValue: 60},
  {xLabel: 'Consulting', yValue: 80},
  {xLabel: 'Net Revenue', yValue: 0},
  {xLabel: 'Purchases', yValue: -40},
  {xLabel: 'Other Expenses', yValue: -20},
  {xLabel: 'Profit before tax', yValue: 0},
];

export const sanDummydata = [
  {source: 'India', destination: 'Italy', value: 8},
  {source: 'USA', destination: 'Russia', value: 4},
  {source: 'India', destination: 'Russia', value: 2},
  {source: 'Italy', destination: 'Israel', value: 8},
  {source: 'Russia', destination: 'Israel', value: 4},
  {source: 'Italy', destination: 'Japan', value: 2},
  {source: 'Israel', destination: 'Switzerland', value: 3},
  {source: 'USA', destination: 'Russia', value: 7},
  {source: 'Russia', destination: 'Japan', value: 13},
  {source: 'Italy', destination: 'Canada', value: 19},
  {source: 'Italy', destination: 'USA', value: 3},
  {source: 'China', destination: 'Korea', value: 9},
  {source: 'Canada', destination: 'Russia', value: 7},
  {source: 'USA', destination: 'Japan', value: 12},
  {source: 'Korea', destination: 'Canada', value: 1},
  {source: 'India', destination: 'Russia', value: 11},
  {source: 'China', destination: 'Switzerland', value: 17},
];

export const singleCarddata = [
  {
    label: 'Total Revenue', value: 14500
  }
];

export const lastCarddata = [
  {
    label: '$378,300', value: '23 MARCH 00:00 UTC'
  }
];

export const bankCarddata = [
  { 
    label: 'Axis Bank', value: '$1,148.24'
  }
];

export const balanceCarddata = [
  { 
    label: 'Visitors', value: '10,483'
  },
  { 
    label: 'Orders', value: '4,725'
  },
];

export const visitorCarddata = [
  { 
    label: 'Outgoing', value: '$1473.32'
  },
  { 
    label: 'Incoming', value: '$754.29'
  },
];

export const incomeCarddata = [
  {
    label: 'Income', value: '+20%', date:'16 Jan 2019'
  }
];

export const outcomeCarddata = [
  {
    label: 'Outcome', value: '-12%', date:'26 Jan 2019'
  }
];

export const sentCarddata = [
  {
    label: 'Alex Williams', value: '-$127', date:'Sent 7h ago'
  }
];

export const receivedCarddata = [
  {
    label: 'Victoria Vals', value: '+$359', date:'Received 3h ago'
  }
];

export const dashCarddata = [
  { label: 'Tesla' },
  { label: 'Amazon' },
  { label: 'SpaceX' },
];